import lessonEditHistoryApi from "@apis/lesson.edit.open.history.api.ts";
import { useErrorHandler } from "@plugins/common/composables/error.ts";

export const useResourceEdit = () => {
  const { passiveApiFailHandler } = useErrorHandler();
  const handleSaveLessonEditHistory = (lessonUuid, assignmentUuid = null) => {
    lessonEditHistoryApi.saveLessonEditHistory(lessonUuid, assignmentUuid).then((response) => {
      if (response.code !== "ok") {
        passiveApiFailHandler();
      }
    }, passiveApiFailHandler);
  };
  return {
    handleSaveLessonEditHistory,
  };
};
